export enum InferredStateEnum {
  UNFOLDING = "UNFOLDING",
  FOLDING = "FOLDING",
  OPENING = "OPENING",
  CLOSING = "CLOSING",
  PROGRESS_UP = "PROGRESS_UP",
  PROGRESS_DOWN = "PROGRESS_DOWN",
  WAITING_FOR_STATE = "WAITING_FOR_STATE",
  PAUSED = "PAUSED",
  ERROR = "ERROR",
  UP = "UP",
  FOLDED = "FOLDED",
  UNFOLDED = "UNFOLDED",
  UNKNOWN = "UNKNOWN",
  LOCKED = "LOCKED",
}
